import React from 'react';
import PropTypes from 'prop-types';

import { BackLink } from './Buttons';

const AdminPageTitle = props => {
  return (
    <div className="is-flex align-items-center">
      <BackLink to={props.to || '/admin'} />
      <p className="admin-page-title ml-20px">{props.title}</p>
    </div>
  );
};

AdminPageTitle.propTypes = {
  title: PropTypes.string,
  to: PropTypes.string,
};

export default AdminPageTitle;
